
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { IconButton } from '@material-ui/core'
import { deleteIcon, SvgIcon } from '../../../../components/icons'
import * as appActions from '../../../../store/actions/appActions'
import * as transcriptViewerActions from '../../transcriptViewerActions'

import './RemoveTranscript.scss'

const RemoveTranscript = ({ transcriptId, texts, showAlert, removeTranscripts }) => {
  const handleClick = () => {
    showAlert({
      message: texts['confirm-delete-message'],
      buttons: [
        {
          label: texts['yes'],
          onClick: () => {
            removeTranscripts(['transcriptId', '=', transcriptId])
          },
        },
        {
          label: texts['no'],
          onClick: () => {},
        },
      ],
      className: 'confirm-delete',
    })
  }

  return (
    <div className="removeTranscriptButton roundButton" title={texts['tooltip-delete']}>
      <IconButton onClick={handleClick}><SvgIcon svg={deleteIcon} /></IconButton>
    </div>
  )
}

RemoveTranscript.propTypes = {
  transcriptId: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
  showAlert: PropTypes.func.isRequired,
  removeTranscripts: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    texts: state.app.texts,
  }), dispatch => bindActionCreators({
    showAlert: appActions.showAlert,
    removeTranscripts: transcriptViewerActions.removeTranscripts,
  }, dispatch),
)(RemoveTranscript);
